import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NzBreadCrumbModule} from 'ng-zorro-antd/breadcrumb';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {GnLayoutComponent} from './layout.component';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {GnLayoutCenterComponent} from './center.component';


@NgModule({
  declarations: [
    GnLayoutComponent,
    GnLayoutCenterComponent
  ],
  exports: [
    GnLayoutComponent,
    GnLayoutCenterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NzLayoutModule,
    NzBreadCrumbModule,
    NzMenuModule,
    NzIconModule
  ]
})
export class GnLayoutModule {
}
